import { render, staticRenderFns } from "./ListeDesCommandes.vue?vue&type=template&id=a75932a4&"
import script from "./ListeDesCommandes.vue?vue&type=script&lang=js&"
export * from "./ListeDesCommandes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a75932a4')) {
      api.createRecord('a75932a4', component.options)
    } else {
      api.reload('a75932a4', component.options)
    }
    module.hot.accept("./ListeDesCommandes.vue?vue&type=template&id=a75932a4&", function () {
      api.rerender('a75932a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Commandes/ListeDesCommandes.vue"
export default component.exports